class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.applyDiscountCode();    
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
        const discountInput = this.querySelector('#discount-code-input');
        const discountData = localStorage.getItem('discountCode');
        if (discountInput && discountData) {
          try {
            const parsed = JSON.parse(discountData);
            if (parsed.code) {              
              discountInput.value = parsed.code;
              discountInput.closest('.cart-sidebar-discount')?.classList.add('active');

              const applyBtn = this.querySelector("#apply-discount-btn") || this.querySelector("#apply-discount-btn-main");
              const clearBtn = this.querySelector("#clear-discount-btn");
              if (applyBtn) applyBtn.classList.add('hidden');
              if (clearBtn) clearBtn.classList.remove('hidden');
            }
          } catch (e) {
            console.error("Invalid discountCode in localStorage:", e);
          } finally {
            this.applyDiscountCode();
          }
        }
        else {
          discountInput.closest('.cart-sidebar-discount')?.classList.add('active');

          const applyBtn = this.querySelector("#apply-discount-btn") || this.querySelector("#apply-discount-btn-main");
          const clearBtn = this.querySelector("#clear-discount-btn");
          if (applyBtn) applyBtn.classList.add('hidden');
          if (clearBtn) clearBtn.classList.remove('hidden');

          const discountError = localStorage.getItem('discountError');
          if (discountError) {
            this.querySelector(".cart-discount-error")?.classList.remove('hidden');
            this.querySelector(".cart-discount-success")?.classList.add('hidden');
            discountInput.value = discountError;
          }
          this.applyDiscountCode();
        }
      })
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        if (window.location.pathname.search('/cart') !== -1) {
          localStorage.removeItem('discountError');
        }
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section',
      // },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'drawer__footer',
        section: document.getElementById('drawer__footer').dataset.id,
        selector: '.rocket-drawer__footer-table',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {        
        const parsedState = JSON.parse(state)
        if(parsedState.item_count) {
          document.querySelector('.rocket-header__desktop-nav__links-count').innerHTML = `${parsedState.item_count}`;
          document.querySelector('.rocket-header__desktop-nav__links-count-mb').innerHTML = `${parsedState.item_count}`;
          document.querySelector('.drawer__heading-count').innerHTML = `( ${parsedState.item_count} )`;
          document.querySelector('#drawer__heading-count_symcs').innerHTML = `( ${parsedState.item_count} )`;
          if(document.querySelector('navigation-tab .tab-cart .total-item')) {
            document.querySelector('navigation-tab .tab-cart .total-item').innerHTML = `( ${parsedState.item_count} )`;
          }

          if(document.querySelector('.rocket-header__desktop-nav__links-count')) {
            document.querySelector('.rocket-header__desktop-nav__links-count').innerHTML = `${parsedState.item_count}`;
            document.querySelector('.rocket-header__desktop-nav__links-count-mb').innerHTML = `${parsedState.item_count}`;
          }
        } else if(parsedState.item_count === 0) {
          if(document.querySelector('navigation-tab .tab-cart .total-item')) {
            document.querySelector('navigation-tab .tab-cart .total-item').innerHTML = `( ${parsedState.item_count} )`;
          }

          if(document.querySelector('.rocket-header__desktop-nav__links-count')) {
            document.querySelector('.rocket-header__desktop-nav__links-count').innerHTML = `${parsedState.item_count}`;
            document.querySelector('.rocket-header__desktop-nav__links-count-mb').innerHTML = `${parsedState.item_count}`;
          }
        }

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        try {
          this.getSectionsToRender().forEach((section) => {
            
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        } catch (error) {
          console.error("Error: ", error)
        }
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);
        this.applyDiscountCode();

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
        // update count wishlist with cart drawer 
        let countWishlist = document.getElementById('count-wish-list-general');
        if (countWishlist) {
          const wishlistCountElements = document.querySelectorAll('.wishlist-drawer-count');
          if (wishlistCountElements && wishlistCountElements.length > 0) {
              wishlistCountElements.forEach((element) => {
                element.innerHTML = countWishlist.innerHTML;
              });
          }
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
  refreshCartDrawer() {    
    this.onCartUpdate();
  }
  
  applyDiscountCode() {
    
    let discountCart = '';
    let applyBtn = '';
    if (window.location.pathname.search('/cart') !== -1) {
      discountCart = this;
      applyBtn = discountCart.querySelector("#apply-discount-btn-main");
    } else {
      discountCart = this.closest('cart-drawer');
      applyBtn = discountCart?.querySelector("#apply-discount-btn");
    }
    
    let discountCodeInput = discountCart?.querySelector("#discount-code-input");
    let clearBtn = discountCart?.querySelector("#clear-discount-btn");
    let discountError = discountCart?.querySelector(".cart-discount-error");
    let discountSuccess = discountCart?.querySelector(".cart-discount-success");
    let labelBtn = applyBtn?.getAttribute('data-label');
    let labelBtnProgress = applyBtn?.getAttribute('data-label-inprogress');
    let totalCartSelector = discountCart?.querySelector(".cart__subtotal .money");
    let thisCart = this;
    let checkoutContainer = document.createElement('div');
    document.body.appendChild(checkoutContainer);
    if(localStorage.getItem("discountCode")) {
      discountError?.classList.add('hidden');
      discountSuccess?.classList.remove('hidden');
      clearBtn?.classList.remove('hidden');
      applyBtn?.classList.add('hidden');
      let parsedData = JSON.parse(localStorage.getItem("discountCode"));
      if (discountCodeInput) {
        discountCodeInput.value = parsedData.code;
        discountCodeInput.closest('.cart-sidebar-discount').classList.add('active');
      }
    }
    discountCodeInput?.addEventListener("input", ()=> {     
      clearBtn.classList.add('hidden');
      applyBtn?.classList.remove('hidden');
      localStorage.removeItem('discountError');
      if(discountCodeInput.value != '') {
        discountCodeInput.closest('.cart-sidebar-discount').classList.add('active');
      }else {
        discountCodeInput.closest('.cart-sidebar-discount').classList.remove('active');
        discountError?.classList.add('hidden');
      }
    });
    if(applyBtn)
    applyBtn.addEventListener("click", function(e){
      e.preventDefault()
      applyDiscount(discountCodeInput?.value);
    });
    if(clearBtn)
      clearBtn.addEventListener("click", function(e){
        e.preventDefault()
        clearDiscount();
      });
    function clearDiscount() {
      clearBtn.classList.add('hidden');
      applyBtn?.classList.remove('hidden');
      discountCodeInput.closest('.cart-sidebar-discount').classList.remove('active');
      discountSuccess?.classList.add('hidden');
      discountError?.classList.add('hidden');
      discountCodeInput.value = "";
      clearLocalStorage();
      fetch('/checkout?discount=CLEAR')
      .then(() => {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          const sourceQtyTable = sourceQty.querySelector('#table-cart-items');
          const cartFooterVal = html.querySelector('.rocket-drawer__footer-table-container table');
          const sourceQtyPage = sourceQty.querySelector('#main-cart-items .cart-items');
          const cartPageFooterVal = html.querySelector('.rocket-drawer__footer-table-container table');
          
          let attemptsPage = 0;
          const maxAttemptsPage = 10;

          const checkElmCartPage = setInterval(() => {
            attemptsPage++;
            
            const cartItemsContainer = document.querySelector('cart-items #main-cart-items .cart-items');
            const mainCartItemsFooter = document.querySelector('cart-items .rocket-drawer__footer-table-container table');
            
            if (cartItemsContainer && sourceQtyPage) {
              clearInterval(checkElmCartPage);
              cartItemsContainer.innerHTML = sourceQtyPage.innerHTML;
              mainCartItemsFooter.innerHTML = cartPageFooterVal.innerHTML;
            } else if (attemptsPage >= maxAttemptsPage) {
              clearInterval(checkElmCartPage);
            }
          }, 10);
          let attempts = 0;
          const checkElmCart = setInterval(() => {
            attempts++;
            if(document.querySelector('cart-drawer-items #table-cart-items') && document.querySelector('.rocket-drawer__footer-table-container--table table')) {
              clearInterval(checkElmCart);
              document.querySelector('cart-drawer-items #table-cart-items').innerHTML = sourceQtyTable.innerHTML;
              document.querySelector('.rocket-drawer__footer-table-container--table table').innerHTML = cartFooterVal.innerHTML;
            }
            else if (attempts >= 30) {
              clearInterval(checkElmCart);
            }
          }, 10);
        })
        .catch((e) => {
          console.error(e);
        });
      });
    }
    function clearLocalStorage() {
      if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
      localStorage.removeItem("discountCode");
    }
    function applyDiscount(code) {
      if (applyBtn) {
        applyBtn.style.pointerEvents = "none";
        applyBtn.innerHTML = labelBtnProgress ? labelBtnProgress : "Applying...";
      }
    
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': "*/*",
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
        referrerPolicy: 'strict-origin-when-cross-origin'
      })
      .then(function (response) {
        if (response.status === 200) {
          return fetch("/cart.js").then(res => res.json());
        } else {
          discountError?.classList.remove('hidden');
          discountSuccess?.classList.add('hidden');
        }
      })
      .then(function (cart) {
        const appliedDiscounts = cart.cart_level_discount_applications;
        const hasLineItemDiscount = cart.items.some(item => item.line_level_discount_allocations.length > 0);
        const discountCodes = cart.discount_codes || [];
        const lastDiscount = discountCodes[discountCodes.length - 1];
        const isLastDiscountInvalid = lastDiscount && lastDiscount.applicable;
    
        if (isLastDiscountInvalid) {
          discountError?.classList.add('hidden');
          discountSuccess?.classList.remove('hidden');
          localStorage.removeItem('discountError');
          localStorage.setItem("discountCode", JSON.stringify({
            code: code.trim(),
            totalCart: cart.original_total_price
          }));
    
          if (totalCartSelector && typeof Shopify !== "undefined") {
            totalCartSelector.innerHTML = `<s>${Shopify.formatMoney(cart.original_total_price)}</s> ${Shopify.formatMoney(cart.total_price)}`;
          }
          thisCart.refreshCartDrawer();
        } else {
          if (localStorage.getItem("discountCode")) {
            if (totalCartSelector && typeof Shopify !== "undefined") {
              totalCartSelector.innerHTML = `<s>${Shopify.formatMoney(cart.original_total_price)}</s> ${Shopify.formatMoney(cart.total_price)}`;
            }
            localStorage.setItem('discountError', discountCodeInput.value);
            thisCart.refreshCartDrawer();
            clearDiscount();
          }
          discountError?.classList.remove('hidden');
          discountSuccess?.classList.add('hidden');
        }
      })
      .catch(function (error) {
        console.error("error:", error.message);
        clearLocalStorage();
        discountError?.classList.remove('hidden');
      })
      .finally(() => {
        if (applyBtn) {
          applyBtn.innerHTML = labelBtn;
          applyBtn.style.pointerEvents = "all";
        }
        applyBtn?.classList.add('hidden');
        clearBtn?.classList.remove('hidden');
        const discountError = localStorage.getItem('discountError');
        if (discountError) {
          discountCodeInput.value = discountError;
        }
      });
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function isOutOfViewport(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return (
      rect.bottom < 0 ||
      rect.top > windowHeight ||
      rect.right < 0 ||
      rect.left > windowWidth
  )
}

function toggleStickyBar() {
  const productButtons = document.querySelector('.rocket-footer')
  const stickyBar = document.querySelector('cart-page .drawer__footer')
  if (!productButtons || !stickyBar) return;
  if (isOutOfViewport(productButtons)) {
    stickyBar.classList.remove('hidden')
  } else {
    // stickyBar.classList.add('hidden')
  }
}

window.addEventListener('scroll', toggleStickyBar)
toggleStickyBar()
document.addEventListener('DOMContentLoaded', function () {
  const  urlParams  =  new URLSearchParams(window.location.search);
  const select = urlParams.get("select");
  if (document.querySelector('[tab-open="wishlist-items"]')) {
    if (select == 'wishlist') {
      document.querySelector('[tab-open="wishlist-items"]').click();
    } else {
      document.querySelector('[tab-open="cart-items"]').click();
    }
  }
})